import { Component, Injectable, Input } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { DataFilterDisplayService } from '../interface';
import { DynamicOptionsComponent } from './dynamic-options';

@Component({
  selector: 'automata-empty-string',
  template: ``,
  styles: [``],
  standalone: true,
})
export class EmptyStringComponent implements DynamicOptionsComponent {
  @Input() initialValue: string;
  selectedValue$ = of('');

  getSelectedValue(): string {
    return '';
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [];
  }

  isFormValid(): boolean {
    return true;
  }
}

@Injectable({ providedIn: 'root' })
export class EmptyStringDisplayService implements DataFilterDisplayService {
  getDisplay(_value: unknown): Observable<string> {
    return of('');
  }
}
